import React from 'react';
import { Link } from 'react-router';

export default function UnCompletedActivityHeader({
	client, 
	scheduleName, 
	avatar, 
	assignedUser, 
	isMeeting = false,
	location = null
}) {
	return (
		<div className="unCompletedActivityHeader">
			<div className={`unCompletedActivityHeader__withCompanyAndStaff ${isMeeting ? 'meeting' : 'phonecall'}`}>
				<strong>
					{scheduleName} with
					<Link to={`/clients/${client.id}`}>{client.name}</Link>
					completed by
					{avatar}
					{assignedUser &&
						<Link to={`/teams/user/${assignedUser.id}`}>{`${assignedUser.firstName} ${assignedUser.lastName}`}</Link>
					}
				</strong>
				{location &&
					<span>( {location.capitalise()} )</span>
				}
			</div>
		</div>
	)
}




// WEBPACK FOOTER //
// ./app/components/client-timeline/items/CompletedActivityHeader.js